import React, { Component } from 'react';
import FacetContent from "../../common/FacetContent";
import ConjunctiveFacet from "./ConjunctiveFacet";
import DisjunctiveFacet from "./DisjunctiveFacet";
export default class Facet extends Component {
  render() {
    return /*#__PURE__*/React.createElement(FacetContent, {
      facet: this.props.facet,
      facetType: this.props.facet.get('type'),
      filters: this.props.filters,
      hiddenFilters: this.props.hiddenFilters,
      itemFactory: this.props.itemFactory,
      onFacetProductClick: this.props.onFacetProductClick,
      perspective: this.props.perspective,
      sortingLogicForCategory: this.props.sortingLogicForCategory,
      stateChangeRequested: this.props.stateChangeRequested,
      FacetComponent: this.props.FacetComponent,
      ConjunctiveFacet: ConjunctiveFacet,
      DisjunctiveFacet: DisjunctiveFacet
    });
  }
}